module.exports = {
	"suggestion": "findify-components-autocomplete--suggestion-item__suggestion",
	"highlightedText": "findify-components-autocomplete--suggestion-item__highlightedText",
	"highlighted": "findify-components-autocomplete--suggestion-item__highlighted",
	"icon": "findify-components-autocomplete--suggestion-item__icon",
	"withIcon": "findify-components-autocomplete--suggestion-item__withIcon",
	"trending": "findify-components-autocomplete--suggestion-item__trending"
};